import { useEffect } from 'react';

const faviconMap = {
  default: {
    img: 'assets/favicon.svg',
    type: 'image/svg+xml',
  },
  OP: {
    img: 'assets/favicon-op.png',
    type: 'image/png',
  },
};

type params = {
  tenant: keyof typeof faviconMap;
};

export const useFavicon = ({ tenant = 'default' }: params) => {
  const favicon = faviconMap[tenant] || faviconMap.default;
  useEffect(() => {
    const oldFavicon = document.querySelector('#favicon');
    if (oldFavicon) {
      document.head.removeChild(oldFavicon);
    }

    const newFavicon = document.createElement('link');
    newFavicon.rel = 'icon';
    newFavicon.id = 'favicon';
    newFavicon.href = favicon.img;
    newFavicon.type = favicon.type;
    document.head.appendChild(newFavicon);
  }, [favicon]);

  return null;
};
